import { L10n, loadCldr, setCulture } from "@syncfusion/ej2-base";
import numberingSystems from "@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json";
import caGregorian from "@syncfusion/ej2-cldr-data/main/de-CH/ca-gregorian.json";
import currencies from "@syncfusion/ej2-cldr-data/main/de-CH/currencies.json";
import numbers from "@syncfusion/ej2-cldr-data/main/de-CH/numbers.json";
import timeZoneNames from "@syncfusion/ej2-cldr-data/main/de-CH/timeZoneNames.json";

/**
 * Registers the Swiss German culture, CLDR data and translations used by all
 * Syncfusion components. Must run once before the application bootstraps.
 */
export function registerSwissLocale(): void {
    setCulture("de-CH");

    loadCldr(numberingSystems, caGregorian, currencies, numbers, timeZoneNames);

    L10n.load({
        "de-CH": {
            schedule: {
                day: "Tag",
                week: "Woche",
                workWeek: "Arbeitswoche",
                month: "Monat",
                today: "Heute",
                saveButton: "Speichern",
                cancelButton: "Abbrechen",
                deleteButton: "Löschen",
                editEvent: "Termin bearbeiten",
                start: "Startzeit",
                end: "Endzeit",
                yes: "Ja",
                no: "Nein",
                title: "Auftrag",
                description: "Beschreibung",
            },
            calendar: {
                today: "Heute",
            },
        },
    });
}
